// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-view_container__lsuE_","content":"loading-view_content__PCp9F"};